<template>
  <OrganismModal
    v-model:is-shown="isModalOpen"
    data-cy="robin-device-helper-modal"
    :title="t('subscription.equipments.robinDeviceHelperModal.title')"
    size="lg"
    has-separator
    @cancel="handleClose"
  >
    <AtomText
      :content-html="
        t('subscription.equipments.robinDeviceHelperModal.content.whatIsRobin.description')
      "
      data-cy="what-is-robin-description"
      font-size="text-sm"
    />
    <AtomText
      class="list-disc list-inside pl-2"
      :content-html="t('subscription.equipments.robinDeviceHelperModal.content.whatIsRobin.list')"
      is-tag="ul"
      data-cy="what-is-robin-list"
      font-size="text-sm"
    />
    <AtomText
      :text="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.description')"
      data-cy="device-forms-description"
      font-size="text-sm"
      class="mt-4"
    />

    <div class="flex flex-col sm:flex-row gap-[46px] w-full mt-5">
      <div class="flex-1">
        <AtomText
          :text="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.box.label')"
          data-cy="device-forms-box-label"
          font-size="text-sm"
          class="text-center w-full"
        />
        <AtomText
          :text="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.box.title')"
          data-cy="device-forms-box-title"
          font-style="font-bold"
          font-size="text-sm"
          class="text-center w-full"
        />
        <img
          :src="robin_device"
          :alt="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.box.title')"
          data-cy="device-forms-box-photo"
          class="rounded-lg w-full mt-1"
        />
      </div>
      <div class="flex-1">
        <AtomText
          :text="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.core.label')"
          data-cy="device-forms-core-label"
          font-size="text-sm"
          class="text-center w-full"
        />
        <AtomText
          :text="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.core.title')"
          data-cy="device-forms-core-title"
          font-style="font-bold"
          font-size="text-sm"
          class="text-center w-full"
        />
        <img
          :src="robin_core_device"
          :alt="t('subscription.equipments.robinDeviceHelperModal.content.deviceForms.core.title')"
          data-cy="device-forms-core-photo"
          class="rounded-lg w-full mt-1"
        />
      </div>
    </div>

    <template #footer="{ cancel }">
      <div class="flex justify-end max-sm:flex-col-reverse">
        <MoleculeButton
          data-cy="robin-device-helper-modal-close-button"
          variant="tertiary"
          :label="t('common.close')"
          @click="cancel"
        />
      </div>
    </template>
  </OrganismModal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import robin_core_device from '@/assets/images/subscription/robin-core-device.jpg';
import robin_device from '@/assets/images/subscription/robin-device.jpg';

const props = defineProps<{
  isOpen: boolean;
}>();

const emit = defineEmits(['update:isOpen']);

const { t } = useI18n();

const isModalOpen = computed({
  get: () => props.isOpen,
  set: (newState: boolean) => {
    emit('update:isOpen', newState);
  },
});

const handleClose = () => (isModalOpen.value = false);
</script>
